import { GravityFormsState, GravityFormsStateProperty, GravityFormsStateValue } from './state/GravityFormsProvider';
import { GravityFormFragmentFormFieldNodes } from './types';
import { FormFieldValuesInput } from '../../__generated__/graphql';

export const mapFormFieldsToStateFields = (nodes: GravityFormFragmentFormFieldNodes): GravityFormsState => {
  const state: GravityFormsState = {
    errors: {},
    fields: {
      addressFields: {},
      captchaFields: {},
      checkboxFields: {},
      dateFields: {},
      emailFields: {},
      hiddenFields: {},
      multiSelectFields: {},
      nameFields: {},
      numberFields: {},
      phoneFields: {},
      radioFields: {},
      selectFields: {},
      textAreaFields: {},
      textFields: {},
      timeFields: {},
      websiteFields: {},
    },
    initialized: false,
  };

  for (const node of nodes) {
    if (!node.__typename) {
      continue;
    }

    switch (node.__typename) {
      case 'AddressField': {
        state.fields.addressFields = {
          ...state.fields.addressFields,
          [node.databaseId]: {
            addressValues: {},
            id: node.databaseId,
          },
        };
        break;
      }
      case 'CaptchaField': {
        state.fields.captchaFields = {
          ...state.fields.captchaFields,
          [node.databaseId]: {
            id: node.databaseId,
            value: '',
          },
        };
        break;
      }
      case 'CheckboxField': {
        state.fields.checkboxFields = {
          ...state.fields.checkboxFields,
          [node.databaseId]: {
            checkboxValues: [],
            id: node.databaseId,
          },
        };
        break;
      }
      case 'DateField': {
        state.fields.dateFields = {
          ...state.fields.dateFields,
          [node.databaseId]: {
            id: node.databaseId,
            value: '',
          },
        };
        break;
      }
      case 'EmailField': {
        state.fields.emailFields = {
          ...state.fields.emailFields,
          [node.databaseId]: {
            emailValues: {
              value: '',
            },
            id: node.databaseId,
          },
        };
        break;
      }
      case 'HiddenField': {
        state.fields.hiddenFields = {
          ...state.fields.hiddenFields,
          [node.databaseId]: {
            id: node.databaseId,
            value: '',
          },
        };
        break;
      }
      case 'MultiSelectField': {
        state.fields.multiSelectFields = {
          ...state.fields.multiSelectFields,
          [node.databaseId]: {
            id: node.databaseId,
            values: [],
          },
        };
        break;
      }
      case 'NameField': {
        state.fields.nameFields = {
          ...state.fields.nameFields,
          [node.databaseId]: {
            id: node.databaseId,
            nameValues: {},
          },
        };
        break;
      }
      case 'NumberField': {
        state.fields.numberFields = {
          ...state.fields.numberFields,
          [node.databaseId]: {
            id: node.databaseId,
            value: '',
          },
        };
        break;
      }
      case 'PhoneField': {
        state.fields.phoneFields = {
          ...state.fields.phoneFields,
          [node.databaseId]: {
            id: node.databaseId,
            value: '',
          },
        };
        break;
      }
      case 'RadioField': {
        state.fields.radioFields = {
          ...state.fields.radioFields,
          [node.databaseId]: {
            id: node.databaseId,
            value: '',
          },
        };
        break;
      }
      case 'SelectField': {
        state.fields.selectFields = {
          ...state.fields.selectFields,
          [node.databaseId]: {
            id: node.databaseId,
            value: '',
          },
        };
        break;
      }
      case 'TextAreaField': {
        state.fields.textAreaFields = {
          ...state.fields.textAreaFields,
          [node.databaseId]: {
            id: node.databaseId,
            value: '',
          },
        };
        break;
      }
      case 'TextField': {
        state.fields.textFields = {
          ...state.fields.textFields,
          [node.databaseId]: {
            id: node.databaseId,
            value: '',
          },
        };
        break;
      }
      case 'TimeField': {
        state.fields.timeFields = {
          ...state.fields.timeFields,
          [node.databaseId]: {
            id: node.databaseId,
            value: '',
          },
        };
        break;
      }
      case 'WebsiteField': {
        state.fields.websiteFields = {
          ...state.fields.websiteFields,
          [node.databaseId]: {
            id: node.databaseId,
            value: '',
          },
        };
        break;
      }
      case 'ConsentField':
      case 'FileUploadField':
      case 'HtmlField':
      case 'ImageChoiceField':
      case 'ListField':
      case 'MultiChoiceField':
      case 'OptionCheckboxField':
      case 'OptionRadioField':
      case 'OptionSelectField':
      case 'PageField':
      case 'PasswordField':
      case 'PostCategoryCheckboxField':
      case 'PostCategoryMultiSelectField':
      case 'PostCategoryRadioField':
      case 'PostCategorySelectField':
      case 'PostContentField':
      case 'PostCustomCheckboxField':
      case 'PostCustomDateField':
      case 'PostCustomEmailField':
      case 'PostCustomFileuploadField':
      case 'PostCustomHiddenField':
      case 'PostCustomListField':
      case 'PostCustomMultiSelectField':
      case 'PostCustomNumberField':
      case 'PostCustomPhoneField':
      case 'PostCustomRadioField':
      case 'PostCustomSelectField':
      case 'PostCustomTextAreaField':
      case 'PostCustomTextField':
      case 'PostCustomTimeField':
      case 'PostCustomWebsiteField':
      case 'PostExcerptField':
      case 'PostImageField':
      case 'PostTagsCheckboxField':
      case 'PostTagsMultiSelectField':
      case 'PostTagsRadioField':
      case 'PostTagsSelectField':
      case 'PostTagsTextField':
      case 'PostTitleField':
      case 'ProductCalculationField':
      case 'ProductHiddenField':
      case 'ProductPriceField':
      case 'ProductRadioField':
      case 'ProductSelectField':
      case 'ProductSingleField':
      case 'QuantityHiddenField':
      case 'QuantityNumberField':
      case 'QuantitySelectField':
      case 'SectionField':
      case 'ShippingRadioField':
      case 'ShippingSelectField':
      case 'ShippingSingleField':
      case 'TotalField':
      default:
        break;
    }
  }

  return state;
};

export const getFieldValues = (state: GravityFormsState) =>
  Object.values(state.fields).flatMap((value: GravityFormsStateProperty) => {
    // eslint-disable-next-line @stylistic/max-len
    return (Object.values(value) as GravityFormsStateValue[]).reduce<FormFieldValuesInput[]>((acc, curr): FormFieldValuesInput[] => {
      if (curr.id) {
        return [
          ...acc,
          {
            ...curr,
            id: Number(curr.id),
          },
        ];
      }

      return acc;
    }, []);
  });
